module.exports = __webpack_public_path__ + "static/media/tudor_juravlea.358108d3.png";